<template>
  <div class="content-wrapper">
    <div class="content-header">
      <div class="title">企业{{$route.query.type ==='aduit' ? '信息完善（审核通过）' : '编辑'}}</div>
    </div>
    <vendor-form ref="form"
      :loading="loading"
      formStatus="edit"
      v-model="vendorInfo" />
    <div class="content-submit">
      <back-button ref="back" />
      <el-button type="primary"
        v-if=" $route.query.type ==='aduit'"
        @click="auditvendor(1)"
        :loading="loading">提交信息</el-button>
      <!-- <el-button type="primary"
        v-if=" $route.query.type ==='aduit'"
        plain
        @click="auditvendor(2)"
        :loading="loading">不通过</el-button> -->
      <el-button type="primary"
        v-if=" $route.query.type ==='partner'"
        @click="updateVendor"
        :loading="loading">保存</el-button>
    </div>
  </div>
</template>
<script>
import { guid } from '@/utils/index'
import VendorForm from './busi/vendor-form.vue'
export default {
  name: 'vender-detail',
  components: { VendorForm },
  data () {
    return {
      loading: false,
      vendorInfo: { codingTypes: [], tagModels: [], tradeTypes: [], menuNodes: [] },
      fetchMap: { aduit: 'getapplyvendor', partner: 'getvendor' }
    }
  },
  methods: {
    getapplyvendor () {
      this.loading = true
      this.$store.dispatch(`vendor/${this.fetchMap[this.$route.query.type]}`, {
        payload: { [this.$route.query.type === 'aduit' ? 'id' : 'vendorId']: this.$route.query.vendorId },
        success: (res) => {
          this.loading = false
          res.data.businessLicenceFile = res.data.businessLicenceFile ? res.data.businessLicenceFile.split(',').map(item => ({ url: item, name: item })) : []
          res.data.tagModels = res.data.tagModels ? res.data.tagModels.split(',') : []
          res.data.tagTypes = res.data.tagTypes ? res.data.tagTypes.split(',').map(item => +item) : []
          res.data.codingTypes = res.data.codingTypes ? res.data.codingTypes.split(',') : []
          res.data.tradeTypes = res.data.tradeTypes ? res.data.tradeTypes.split(',') : []
          res.data.categorys = res.data.categorys || []
          res.data.regulators = res.data.regulatorId ? [res.data.regulatorId] : (res.data.regulators || [])
          res.data.outstockApi = res.data.outstockApi || 0
          res.data.h5Template = res.data.h5Template || 1
          res.data.h5TemplateInland = res.data.h5TemplateInland || 1
          res.data.functions = (res.data.functions || []).map(item => item.funcId)
          if (this.$route.query.type === 'partner') {
            res.data.menuNodes.forEach(item => {
              if (!item.funcId) {
                item.funcId = `custom-${guid()}`
              }
            })
          }

          this.vendorInfo = { ...this.vendorInfo, ...res.data }
          if (this.$route.query.type === 'aduit') {
            this.$nextTick(() => {
              this.getportalmenutree2orgtype()
            })
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getportalmenutree2orgtype () {
      this.loading = true
      this.$store.dispatch('common/getportalmenutree2orgtype', {
        payload: { orgType: 100 },
        success: res => {
          this.loading = false
          res.data.menuNodes.forEach(item => {
            if (!item.funcId) {
              item.funcId = `custom-${guid()}`
            }
          })
          this.vendorInfo.menuNodes = res.data.menuNodes
        },
        fail: () => {
          this.loading = false
          this.vendorInfo.menuNodes = []
        }
      })
    },
    auditvendor (status) {
      this.$refs.form.validate(status, (vendorInfo) => {
        let { id, h5Template, h5TemplateInland, vendorName, vendorPerson, vendorPhone, unifiedCreditCode, vendorEmail, tradeTypes, vendorAddress, adminAccount, regulators, categorys, tagTypes, tagModels, codingTypes, outstockApi, notshowTagTotalUsedCount, businessLicenceFile, functions } = vendorInfo
        if (status === 1) {
          if (tagTypes.indexOf(1) > -1 && codingTypes.indexOf('1') === -1) {
            this.$message.error('定制标签必须使用建批赋码方式')
            return
          }
          if (tagTypes.indexOf(1) > -1 && tagModels.indexOf('1') === -1) {
            this.$message.error('定制标签必须是产品码')
            return
          }
          this.$confirm('确认通过该企业审核?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
            .then(() => {
              this.loading = true
              this.$store.dispatch('vendor/auditvendor', {
                payload: {
                  id,
                  h5Template,
                  h5TemplateInland,
                  status,
                  vendorName,
                  vendorPerson,
                  vendorPhone,
                  unifiedCreditCode,
                  vendorEmail,
                  tradeTypes: tradeTypes.join(','),
                  vendorAddress,
                  adminAccount,
                  regulators,
                  categorys,
                  tagTypes: tagTypes.join(','),
                  tagModels: tagModels.join(','),
                  codingTypes: codingTypes.join(','),
                  outstockApi,
                  notshowTagTotalUsedCount,
                  businessLicenceFile: businessLicenceFile.map(item => item.url).join(','),
                  functions: functions.filter(item => typeof item === 'number').map(item => ({ funcId: item }))
                },
                success: (res) => {
                  this.loading = false
                  this.$refs.back.back()
                },
                fail: () => {
                  this.loading = false
                }
              })
            })
        } else {
          this.$prompt('请输入不通过原因', '提示', { confirmButtonText: '确定', cancelButtonText: '取消' }).then(({ value }) => {
            this.loading = true
            this.$store.dispatch('vendor/auditvendor', {
              payload: { id, status, auditResult: value },
              success: (res) => {
                this.loading = false
                this.$refs.back.back()
              },
              fail: () => {
                this.loading = false
              }
            })
          })
        }
      })
    },
    updateVendor () {
      this.$refs.form.validate(1, (vendorInfo) => {
        let { vendorId, h5Template, h5TemplateInland, vendorName, vendorPerson, vendorPhone, unifiedCreditCode, vendorEmail, tradeTypes, vendorAddress, adminAccount, regulators, categorys, tagTypes, tagModels, codingTypes, outstockApi, notshowTagTotalUsedCount, businessLicenceFile, functions } = vendorInfo
        if (tagTypes.indexOf(1) > -1 && codingTypes.indexOf('1') === -1) {
          this.$message.error('定制标签必须使用建批赋码方式')
          return
        }
        if (tagTypes.indexOf(1) > -1 && tagModels.indexOf('1') === -1) {
          this.$message.error('定制标签必须是产品码')
          return
        }
        this.loading = true
        this.$store.dispatch('vendor/updatevendor', {
          payload: {
            vendorId,
            h5Template,
            h5TemplateInland,
            vendorName,
            vendorPerson,
            vendorPhone,
            unifiedCreditCode,
            vendorEmail,
            tradeTypes: tradeTypes.join(','),
            vendorAddress,
            adminAccount,
            regulators,
            categorys,
            tagTypes: tagTypes.join(','),
            tagModels: tagModels.join(','),
            codingTypes: codingTypes.join(','),
            outstockApi,
            notshowTagTotalUsedCount,
            businessLicenceFile: businessLicenceFile.map(item => item.url).join(','),
            functions: functions.filter(item => typeof item === 'number').map(item => ({ funcId: item }))
          },
          success: (res) => {
            this.loading = false
            this.$refs.back.back()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    }
  },
  mounted () {
    this.getapplyvendor()
  }
}
</script>
